module.exports = __webpack_public_path__ + "img/2a609b2.jpg";